import actionTypes from '../constants/action-types';

const moveToFolder = (itemId, targetParentFolderId) => ({
  type: actionTypes.MOVE_TO_FOLDER,
  payload: {
    itemId,
    targetParentFolderId,
  },
});

export default moveToFolder;
